export default "__VITE_PUBLIC_ASSET__a883df25__"